import { pattern } from './pattern';

export const VendorSchema = {
    type: "object",
    properties: {
        businessName: {
            type: "string",
            minLength: 1,
            maxLength: 255,
            errorMessage: {
                type: "Business Name must be a string",
                minLength: "Business Name should be at least 1 character",
                maxLength: "Business Name should be at most 255 characters"
            }
        },
        abn: {
            type: "string",
            pattern: pattern.abn,
            nullable: true,
            errorMessage: {
                pattern: "ABN value should be 11 characters",
            }
        },
        email: {
            type: "string",
            pattern: pattern.email,
            errorMessage: {
                type: "Email must be a string",
                pattern: "Invalid Email Format"
            }
        },
        phoneNumber: {
            type: "string",
            pattern: pattern.phoneNumber,
            minLength: 7,
            maxLength: 20,
            nullable: true,
            errorMessage: {
                pattern: "Invalid Phone Number Format",
                minLength: "Phone Number should be at least 7 characters",
                maxLength: "Phone Number should be at most 20 characters"
            }
        },
        streetAddress: {
            type: "string",
            maxLength: 255,
            nullable: true,
            errorMessage: {
                type: "Street Address must be a string",
                maxLength: "Street Address should be at most 255 characters"
            }
        },
        suburb: {
            type: "string",
            maxLength: 255,
            nullable: true,
            errorMessage: {
                type: "Suburb must be a string",
                maxLength: "Suburb should be at most 255 characters"
            }
        },
        state: {
            type: "string",
            maxLength: 255,
            nullable: true,
            errorMessage: {
                type: "State must be a string",
                maxLength: "State should be at most 255 characters"
            }
        },
        postcode: {
            type: "string",
            maxLength: 10,
            nullable: true,
            pattern: pattern.postcode,
            errorMessage: {
                pattern: "Postcode should only contain characters a-z, A-Z, 0-9",
                maxLength: "Postcode should be at most 10 characters",
            }
        },
        country: {
            type: "string",
            maxLength: 255,
            nullable: true,
            errorMessage: {
                type: "Country must be a string",
                maxLength: "Country should be at most 255 characters"
            }
        },
        website: {
            type: "array",
            nullable: true,
            items: {
                type: "string",
                pattern: pattern.website,
                errorMessage: {
                    pattern: "Invalid Website Format"
                }
            },
            errorMessage: {
                type: "Website must be a string",
                pattern: "Invalid Website Format"
            }
        },
        paymentTerms: {
            type: "number",
            minimum: 1,
            errorMessage: {
                type: "Payment Terms must be a number",
                minimum: "Payment Terms should be greater than or equal to 0"
            }
        },
        contacts: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    isPrimary: { type: "boolean" },
                    firstName: {
                        type: "string",
                        minLength: 1,
                        maxLength: 255,
                        nullable: true,
                        errorMessage: {
                            type: "Contact First Name must be a string",
                            minLength: "Contact First Name should be at least 1 character",
                            maxLength: "Contact First Name should be at most 255 characters"
                        }
                    },
                    lastName: {
                        type: "string",
                        minLength: 1,
                        maxLength: 255,
                        nullable: true,
                        errorMessage: {
                            type: "Contact Last Name must be a string",
                            minLength: "Contact Last Name should be at least 1 character",
                            maxLength: "Contact Last Name should be at most 255 characters"
                        }
                    },
                    email: {
                        type: "string",
                        nullable: true,
                        pattern: pattern.email,
                        errorMessage: {
                            type: "Contact Email must be a string",
                            pattern: "Invalid Contact Email Format"
                        }
                    },
                    phoneNumber: {
                        type: "string",
                        nullable: true,
                        pattern: pattern.phoneNumber,
                        minLength: 7,
                        maxLength: 20,
                        errorMessage: {
                            minLength: "Contact Phone Number should be at least 7 characters",
                            maxLength: "Contact Phone Number should be at most 20 characters",
                            pattern: "Invalid Contact Phone Number Format",
                        }
                    },
                    designation: {
                        type: "string",
                        nullable: true,
                        minLength: 1,
                        maxLength: 255,
                        errorMessage: {
                            type: "Contact Job Role must be a string",
                            minLength: "Contact Job Role should be at least 1 character",
                            maxLength: "Contact Job Role should be at most 255 characters"
                        }
                    },
                },
                additionalProperties: false,
            },
        },
    },
    required: [
        "businessName",
        "email",
        "phoneNumber",
        "paymentTerms",
    ],
    additionalProperties: false,
    errorMessage: {
        required: {
            businessName: "Missing (Business Name)",
            email: "Missing (Email)",
            phoneNumber: "Missing (Phone Number)",
            paymentTerms: "Missing (Payment Terms)",
        },
    },
};
